//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('batchDelPurchLine', {
//        templateUrl: 'views/components/views/batchDelPurchLine/batchDelPurchLine.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'batchDelPurchLineService', function ($stateParams, stateService, translateService, modalService, batchDelPurchLineService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let batchDelPurchLineKeyno = $stateParams.batchdelpurchline_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                bgPurchLineSelection: {
//                    selected: '0',
//                    buttons: [
//                        { id: '0', label: 'batchdelivery_gb_simple', color: 'primary', onClick: () => vm.model.bgPurchLineSelection.selected = '0' },
//                        { id: '1', label: 'batchdelivery_gb_details', color: 'primary', onClick: () => vm.model.bgPurchLineSelection.selected = '1' }
//                    ]
//                },
//                info: {},
//                lockedDelete: false,
//                lockedRollback: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadInfo() {
//                vm.model.info = (await batchDelPurchLineService.getInfo({ batchdelpurchline_keyno: batchDelPurchLineKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgPurchLineSelection = function (value) {
//                vm.model.bgPurchLineSelection.selected = value;
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    batchDelPurchLineService.deleteItem({ batchdelpurchline_keyno: vm.model.info.batchdelpurchline_keyno }).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region BUTTON ROLLBACK PROCEDURE FUNCTION CALL

//            vm.rollbackValues = function () {
//                vm.model.lockedRollback = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    batchDelPurchLineService.rollbackItem({ batchdelpurchline_keyno: vm.model.info.batchdelpurchline_keyno }).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                        		message: response[0].errormessage,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedRollback = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedRollback = false;
//                        	stateService.back();
//                        }
//                    }, () => vm.model.lockedRollback = false);
//                }, () => vm.model.lockedRollback = false);
//            }

//            // #endregion BUTTON ROLLBACK PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadInfo();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
